import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import potions from "./potions.jpg";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <img src={potions} style={{
      height: "50%",
      width: "50%"
    }} />
    <p>{`Hi there , Welcome to The Daily Grind`}</p>
    <p>{`Let's make some software work`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      